import { User } from './types'

export const formatUserName = (user: Pick<User, 'firstName' | 'lastName' | 'isArchived'>) =>
  `${user.firstName} ${user.lastName}${user.isArchived ? ' (Inactive)' : ''}`
